import { render } from "./RejectionLegend.vue?vue&type=template&id=59be68a2"
import script from "./RejectionLegend.vue?vue&type=script&lang=js"
export * from "./RejectionLegend.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__